import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const TRANSLATE_PROVIDERS = [
  ...provideTranslateService(),
  ...provideTranslateHttpLoader({
    prefix: '/assets/i18n/',
    suffix: '.json'
  })
];
